import React from 'react';
import { motion } from 'framer-motion';
import { Eye } from 'lucide-react';
export function LayerXRay() {
  return <section className="py-24 bg-gradient-to-b from-slate-900 to-slate-950" data-id="element-63">
      <div className="max-w-7xl mx-auto px-6" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-65">
          <div className="flex items-center gap-3 mb-4" data-id="element-66">
            <div className="bg-red-600 text-white px-4 py-1 rounded-full text-sm font-semibold" data-id="element-67">
              LAYER 4
            </div>
            <Eye className="w-5 h-5 text-red-600" data-id="element-68" />
          </div>
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-69">
            The X-Ray Overlay
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl" data-id="element-70">
            Borrowed from the streaming world — an optional, on-demand layer of
            context that lives <em data-id="element-71">on top</em> of the scientific core, never
            inside it.
          </p>
        </motion.div>

        {/* Actual presentation slide */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/10 bg-[#2d4a35]" data-id="element-72">
          <img src="https://cdn.magicpatterns.com/uploads/xtZGaeCt9BiT5cpkBkH91T/Screenshot_2026-05-08_at_8.45.03_AM.png" alt="X-Ray overlay — Dr. Firas George Hougeir credentials and study context" className="w-full h-auto block" data-id="element-73" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center text-slate-400 mt-12 italic" data-id="element-74">
          The differentiator — rich context without disrupting the scientific
          core.
        </motion.p>
      </div>
    </section>;
}